export const maskPhoneNumber = (input) => {
    const regex = /^(\d{3})(\d{3})(\d{4})$/;
    const match = regex.exec(input);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return input;
}